import React, { useContext, useEffect, useState } from 'react';
import { Calendar } from '@pcln/date-picker';
import { Box } from 'pcln-design-system';
import { submitChatMessages } from '../../submitChatMessages';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import analytics from '../../analytics/analytics';
import { format } from 'date-fns/format';
import { parse } from 'date-fns/parse';
import { differenceInCalendarDays } from 'date-fns/differenceInCalendarDays';
import { useChatMessagesContext } from '../../hooks/useChatMessagesContext';
import { useLoadingStateContext } from '../../hooks/useLoadingStateContext';
import { useChatUIContext } from '../../hooks/useChatUIContext';
const CalendarComponent = ({
  markerComponentProps,
  isLastMessage
}) => {
  const [resolvedStartDate, setResolvedStartDate] = useState('');
  const [resolvedEndDate, setResolvedEndDate] = useState('');
  const [numberOfNights, setNumberOfNights] = useState(0);
  const {
    submitChatMessagesPayload,
    handleMarkerResponse,
    fetchRequestOptions,
    markerComponents,
    setErrorMessage,
    setStreamingText,
    setIsDisablingInputValue,
    isMobile
  } = useContext(ChatbotDataContext);
  const {
    setLoadingStatus,
    setLoadingStatusMessage
  } = useLoadingStateContext();
  const {
    setOpenErrorComponent
  } = useChatUIContext();
  const {
    chatMessages,
    setChatMessages
  } = useChatMessagesContext();
  const submitChatMessagesOptions = {
    setChatMessages,
    setStreamingText,
    setLoadingStatus,
    setLoadingStatusMessage,
    setErrorMessage,
    setIsDisablingInputValue,
    requestOptions: fetchRequestOptions,
    markerComponents,
    handleMarkerResponse
  };
  useEffect(() => {
    if (resolvedStartDate && resolvedEndDate) {
      let nightsText = '';
      if (numberOfNights && numberOfNights > 1) {
        nightsText = ` (${numberOfNights} nights)`;
      } else if (numberOfNights && numberOfNights === 1) {
        nightsText = ` (${numberOfNights} night)`;
      }
      const chatContent = `Search for hotels with Check-in date - ${resolvedStartDate} and check-out date - ${resolvedEndDate}${nightsText}.`;
      const chatMessage = {
        content: chatContent,
        date: new Date(),
        role: 'user'
      };
      const promptMessage = {
        content: chatContent,
        role: 'user'
      };
      chatMessages.pop();
      const updatedChatMessages = [...chatMessages, chatMessage];
      setChatMessages(updatedChatMessages);
      submitChatMessages(Object.assign({
        submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
          prompts: [promptMessage]
        }),
        setOpenErrorComponent,
        chatMessages: updatedChatMessages
      }, submitChatMessagesOptions)).catch(e => {
        analytics.log({
          message: e === null || e === void 0 ? void 0 : e.message,
          source: 'CalendarComponent'
        });
      });
    }
  }, [resolvedEndDate, resolvedStartDate]);
  const calculateNights = (startDate, endDate) => {
    if (startDate && endDate) {
      const start = new Date(parseInt(startDate.substring(0, 4), 10), parseInt(startDate.substring(4, 6), 10) - 1, parseInt(startDate.substring(6, 8), 10));
      const end = new Date(parseInt(endDate.substring(0, 4), 10), parseInt(endDate.substring(4, 6), 10) - 1, parseInt(endDate.substring(6, 8), 10));
      return differenceInCalendarDays(end, start);
    }
    return 0;
  };
  function handleSelectedDates(e, f) {
    if (e && f) {
      if ((f === null || f === void 0 ? void 0 : f.startDate) && (f === null || f === void 0 ? void 0 : f.endDate)) {
        setNumberOfNights(calculateNights(f.startDate, f.endDate));
        const parsedStartDate = parse(f.startDate, 'yyyyMMdd', new Date());
        const parsedEndDate = parse(f.endDate, 'yyyyMMdd', new Date());
        setResolvedStartDate(format(parsedStartDate, 'EEEE, MMMM dd, yyyy'));
        setResolvedEndDate(format(parsedEndDate, 'EEEE, MMMM dd, yyyy'));
      }
    }
  }
  function handleCalenderRef(ref) {
    var _a;
    ref.style.position = 'relative';
    ref.style.marginLeft = '30px';
    (_a = ref.scrollIntoView) === null || _a === void 0 ? void 0 : _a.call(ref, {
      behavior: 'smooth'
    });
  }
  if (!isLastMessage) {
    return null;
  }
  return React.createElement(Box, {
    mb: 2,
    maxHeight: isMobile ? '300px' : null,
    overflowY: 'auto'
  }, React.createElement(Calendar, {
    monthsToShow: 1,
    isMobile: isMobile,
    monthWidthPx: 300,
    onChange: handleSelectedDates,
    setCalendarRef: handleCalenderRef,
    calendarWrapperStyles: {
      boxShadow: 'lg'
    }
  }));
};
export default CalendarComponent;